import React from "react";
import { NavLink } from "react-router-dom";
import {
  FiHome,
  FiBarChart2,
  FiBookOpen,
  FiUser,
  FiLayout,
  FiX,
} from "react-icons/fi";

const MobileSidebarDrawer = ({ open, onClose }) => {
  return (
    <div
      className={`md:hidden fixed inset-0 z-50 ${open ? "pointer-events-auto" : "pointer-events-none"}`}
      aria-hidden={!open}
    >
      {/* Backdrop */}
      <div
        className={`absolute inset-0 bg-black/40 transition-opacity duration-200 ${open ? "opacity-100" : "opacity-0"}`}
        onClick={onClose}
      />

      {/* Drawer */}
      <div
        className={`absolute left-0 top-0 h-full w-64 bg-white shadow-xl transition-transform duration-300 ${
          open ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between p-4 border-b">
          <div className="text-primary text-xl">
            <span className="font-bold">A</span>
            <span>anya</span>
          </div>
          <button
            aria-label="Close menu"
            onClick={onClose}
            className="p-2 rounded-md hover:bg-gray-100"
          >
            <FiX className="w-6 h-6 text-gray-700" />
          </button>
        </div>

        <nav className="flex flex-col gap-2 p-2">
          <NavLink
            to=""
            end
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-xl ${
                isActive
                  ? "bg-primary text-white"
                  : "text-gray-700 hover:bg-gray-100"
              }`
            }
            onClick={onClose}
          >
            <FiHome className="w-6 h-6" />
            <span className="font-medium">Home</span>
          </NavLink>

          <NavLink
            to="assessment"
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-xl ${
                isActive
                  ? "bg-primary text-white"
                  : "text-gray-700 hover:bg-gray-100"
              }`
            }
            onClick={onClose}
          >
            <FiBarChart2 className="w-6 h-6" />
            <span className="font-medium">Assessment</span>
          </NavLink>

          <NavLink
            to="practice"
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-xl ${
                isActive
                  ? "bg-primary text-white"
                  : "text-gray-700 hover:bg-gray-100"
              }`
            }
            onClick={onClose}
          >
            <FiBookOpen className="w-6 h-6" />
            <span className="font-medium">Practice</span>
          </NavLink>

          <NavLink
            to="tutor"
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-xl ${
                isActive
                  ? "bg-primary text-white"
                  : "text-gray-700 hover:bg-gray-100"
              }`
            }
            onClick={onClose}
          >
            <FiUser className="w-6 h-6" />
            <span className="font-medium">Tutor</span>
          </NavLink>

          <NavLink
            to="dashboard"
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-xl ${
                isActive
                  ? "bg-primary text-white"
                  : "text-gray-700 hover:bg-gray-100"
              }`
            }
            onClick={onClose}
          >
            <FiLayout className="w-6 h-6" />
            <span className="font-medium">Dashboard</span>
          </NavLink>
        </nav>
      </div>
    </div>
  );
};

export default MobileSidebarDrawer;
